import { Pipe, PipeTransform } from '@angular/core';
import { ActionTeam } from '@macs-frontend/web-macs/shared';
import { ActionTeamType } from '@macs-gql';
import { TeamCost } from '@macs-frontend/features/company-management/team-cost/team-cost.types';

@Pipe({ name: 'actionTeamName' })
export class ActionTeamNamePipe implements PipeTransform {
  public transform(
    actionTeam?:
      | Readonly<Pick<ActionTeam, 'type' | 'name' | 'customNumber'>>
      | Readonly<Pick<TeamCost, 'name' | 'customNumber'>>,
  ): any {
    if (!actionTeam) {
      return '';
    }

    const name = actionTeam.name;

    if ('type' in actionTeam) {
      if (actionTeam.type === ActionTeamType.PickUp) {
        return `${name} (pick up)`;
      }

      if (actionTeam.type === ActionTeamType.DropOff) {
        return `${name} (drop off)`;
      }
    }

    // @ts-expect-error
    if (actionTeam.customNumber > 0) {
      return `${name} (custom ${actionTeam.customNumber})`;
    }

    return name;
  }
}
